// @ts-check

/**
 * @const USER_INFO
 * @property {string} ID
 * @property {string} NAME
 * @property {string} CONTACT_ID
 * @property {string} USER_ID
 * @property {string} EMPLOYEE_ID
 * @property {string} USERNAME
 * @property {string} FULL_NAME
 * @property {string} FIRST_NAME
 * @property {string} LAST_NAME
 * @property {string} CUSTOMER_ID
 * @property {string} V_FILE
 * @property {string} IMAGE
 * @property {string} ROLE_GROUPS
 * @property {string} ROLES
 * @property {string} ROLE_NAMES
 * @property {string} POST_LOGIN_URL
 */
const USER_INFO = Object.freeze({
	ID: 'id',
	NAME: 'name',
	CONTACT_ID: 'contactId',
	USER_ID: 'userId',
	EMPLOYEE_ID: 'employeeId',
	USERNAME: 'username',
	FULL_NAME: 'fullname',
	LAST_NAME: 'lastName',
	FIRST_NAME: 'firstName',
	CUSTOMER_ID: 'customerId',
	V_FILE: 'vFile',
	IMAGE: 'image',
	ROLE_GROUPS: 'userRoleGroups',
	ROLES: 'roles',
	// Human-readable legacy role names (obj.Roles), e.g. "CanPark Admin".
	ROLE_NAMES: 'roleNames',
	// True once the user has seen the intro walkthrough (CANapps Home Tour).
	INTRO_COMPLETED: 'introCompleted',
	POST_LOGIN_URL: 'postLoginURL',
});

export default USER_INFO;
